module.exports = __webpack_public_path__ + "static/media/halloween2.8ea310e0.webp";